import React from "react";
import { LifeBuoy } from "lucide-react";
import { useEmergency } from "@/components/EmergencyProvider";

// Ever-present floating crisis dock (bottom-right) available on every screen.
export const FloatingDock = () => {
  const { open } = useEmergency();
  return (
    <button
      onClick={open}
      className="fixed bottom-5 right-5 z-[90] group flex items-center gap-2 pl-3 pr-4 py-3 rounded-full btn-gold font-semibold text-sm shadow-xl transition-all hover:scale-[1.03]"
      data-testid="floating-crisis-dock"
      aria-label="Open crisis support lines"
    >
      <LifeBuoy className="w-5 h-5" />
      <span className="hidden sm:inline">Need Support Now?</span>
      <span className="sm:hidden">Support</span>
    </button>
  );
};

export default FloatingDock;
